/** RMS-порог «достаточно тихо» для выхода из alarm loop (B5 / sound-quality). */
export const ALARM_QUIET_RMS_THRESHOLD = 0.018;

/** Пауза между итерациями alarm loop (мс). */
export const ALARM_LOOP_PAUSE_MS = 400;
